export default "__VITE_ASSET__5e0c9d5b__"